import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
import { marginAttributes } from '../../system/attributes';
export var BadgeRoot = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", ";\n"])), marginAttributes);